// EventCard.jsx
import React from 'react';
import './events.css';
import logo_stb_blue from '../img/logo-stb-blue.png'

// 代替画像URL（public配下に置くか、外部URLでもOK）
const DEFAULT_IMAGE_URL = logo_stb_blue; // public/default-event-image.jpg を使う例

function getStatus(dateStr) {
  if (!dateStr) return null;
  const target = new Date(`${dateStr}T00:00:00`);
  if (isNaN(target)) return null;

  const today = new Date();
  const base  = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const diff  = Math.floor((target - base) / 86_400_000);

  if (diff === 0) return { text: '本日',   cls: 'today'    };
  if (diff === 1) return { text: '明日',   cls: 'tomorrow' };
  if (diff <  0) return { text: '開催済', cls: 'past'     };
  return null;
}

function EventCard({
  imageUrl,
  tags,
  title,
  details,
  content,
  eventDate,
  onClick
}) {
  const isLink = typeof content === 'string' && content.trim().toLowerCase().startsWith('http');
  const isInterview = (tags || []).includes('インタビュー');
  const status = isInterview ? null : getStatus(eventDate);

  const allTags = [
    ...(status ? [{ text: status.text, cls: status.cls }] : []),
    ...(tags || []).map(t => ({ text: t, cls: null }))
  ];

  const resolvedImageUrl = imageUrl || DEFAULT_IMAGE_URL; // ← フォールバック画像を指定

  const CardInner = (
    <div className="event-card" style={{ cursor: 'pointer' }}>
      <div className="event-image-container">
      <img
        src={resolvedImageUrl}
        alt={title}
        className={
          `event-image` +
          (status?.cls === 'past' ? ' event-image--dim' : '') +
          (imageUrl ? '' : ' event-image--default') // ← imageUrlが未指定なら追加
        }
      />
        <ul className={`event-tags${isInterview ? ' event-tags--bottom' : ''}`}>
          {allTags.map((tag, idx) => (
            <li
              key={idx}
              className={
                `event-tag` +
                (tag.cls ? ` event-tag--${tag.cls}` : '')
              }
            >
              {tag.text}
            </li>
          ))}
        </ul>
      </div>

      <div className="event-content">
        <h2 className="event-date">{eventDate}</h2>
        <h2 className="event-title">{title}</h2>
        <p className="event-details">{details}</p>
      </div>
    </div>
  );

  return isLink ? (
    <a href={content.trim()} target="_blank" rel="noopener noreferrer" className="event-link">
      {CardInner}
    </a>
  ) : (
    <div onClick={onClick}>
      {CardInner}
    </div>
  );
}

export default EventCard;
